import { useEffect, useState, useCallback, useContext, useRef } from 'react'; 
import { LoginContext } from "../AuthContext/LoginContext";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import 'pdfmake/build/pdfmake.min.js';
import 'pdfmake/build/vfs_fonts.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TooltipTextPopupCustom from './child/TooltipTextPopupCustom';
import { Link } from "react-router-dom";

const PlantationTableLayer = () => {
  const [plantations, setPlantations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [perPage] = useState(10);
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
 
  
  // Alternative approach: Use a key to force complete re-render of table section
  const [tableKey, setTableKey] = useState(0);
  // Add a ref to track the table container
  const tableRef = useRef(null);
  // Use useRef to store the timeout reference
  const filterTimeoutRef = useRef(null);

  // Update table key when plantations change to force clean re-render
  useEffect(() => {
    setTableKey(prev => prev + 1);
  }, [plantations]);

  const { hasPermission } = useContext(LoginContext);
  
  // Filter states
  const [filters, setFilters] = useState({
    district: '',
    category: '',
    tehsil: '',
    plantationCampaign: '',
    plantationType: '',
    province: '',
    yearOfPlantation: '',
    siteType: '',
    searchQuery: '',
    fromDate: '',
    toDate: ''
  });
  
  // Filter options
  const [filterOptions, setFilterOptions] = useState({
    districts: [],
    categories: [],
    tehsils: [],
    plantationCampaigns: [],
    plantationTypes: [],
    provinces: [],
    years: [],
    siteTypes: []
  });

  
  // Fetch filter options
  const fetchFilterOptions = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      
      // Fetch provinces
      const provincesResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/get-provinces`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Fetch districts
      const districtsResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/get-districts`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Fetch categories
      const categoriesResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/get-categories`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Fetch tehsils
      const tehsilsResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/get-tehsils`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Fetch plantation campaigns
      const plantationCampaignsResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/get-plantation-campaign`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Fetch plantation types
      const plantationTypesResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/plantation-type`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const siteTypesResponse = await axios.get(
        `${API_BASE_URL}/api/plantation/pafs/site-type`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Generate years (last 10 years)
      const currentYear = new Date().getFullYear();
      const years = Array.from({ length: 10 }, (_, i) => currentYear - i);
      
      // Site types (you might want to fetch these from API if available)
      // const siteTypes = ['Park', 'Roadside', 'Forest', 'Residential Area', 'Commercial Area'];
      
      setFilterOptions({
        provinces: provincesResponse.data.provinces || [],
        districts: districtsResponse.data.districts || [],
        categories: categoriesResponse.data.categories || [],
        tehsils: tehsilsResponse.data.tehsils || [],
        plantationCampaigns: plantationCampaignsResponse.data.plantationCampaigns || [],
        plantationTypes: plantationTypesResponse.data.plantationTypes || [],
        years,
        siteTypes: siteTypesResponse.data.siteTypes || []
      });
    } catch (error) {
      console.error("Error fetching filter options:", error);
      toast.error("Failed to load filter options.");
    }
  }, [API_BASE_URL]);

  const renderSpeciesName = (speciesName) => {
    if (Array.isArray(speciesName)) {
      return speciesName.join(', ') || 'No Data Found';
    }
    return speciesName || 'No Data Found';
  };

  const fetchPlantations = useCallback(async (page = 1, filterParams = {}) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      
      // Robust request body construction to handle different backend expectations
      const requestBody = {
        perPage: perPage,
        pageNo: page,
        ...filterParams,   // flat spread only — no nesting, no duplicates
      };
      const response = await axios.post(
        `${API_BASE_URL}/api/plantation/pafs/get-all-plantation`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );
      
      if (response.data.success) {
        setPlantations(response.data.data || []);
        setCurrentPage(response.data.currentPage || 1);
        setTotalPages(response.data.totalPages || 1);
        setTotalItems(response.data.totalCount || 0);
      } else {
        toast.error("Failed to fetch plantations.");
        setPlantations([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching plantations:", error);
      toast.error("Error fetching plantations.");
      setPlantations([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [API_BASE_URL, perPage]);

  // Handle filter changes
  const handleFilterChange = useCallback((filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
    setCurrentPage(1);
  }, []);

  // Consolidate data fetching into a single effect that watches filters and page
  useEffect(() => {
    // Clear any existing timeout (for debouncing)
    if (filterTimeoutRef.current) {
      clearTimeout(filterTimeoutRef.current);
    }

    // Debounce the call - short for dropdowns, longer for search
    const debounceDelay = filters.searchQuery ? 500 : 50;

    filterTimeoutRef.current = setTimeout(() => {
      // Prepare active filters by removing empty strings
      const activeFilters = {};
      Object.keys(filters).forEach(key => {
        if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
          activeFilters[key] = filters[key];
        }
      });
      
      fetchPlantations(currentPage, activeFilters);
    }, debounceDelay);

    return () => {
      if (filterTimeoutRef.current) {
        clearTimeout(filterTimeoutRef.current);
      }
    };
  }, [filters, currentPage, fetchPlantations]);

  // Clear all filters
  const clearFilters = useCallback(() => {
    // Clear any pending timeout
    if (filterTimeoutRef.current) {
      clearTimeout(filterTimeoutRef.current);
    }
    
    setFilters({
      district: '',
      category: '',
      tehsil: '',
      plantationCampaign: '',
      plantationType: '',
      province: '',
      yearOfPlantation: '',
      siteType: '',
      searchQuery: ''
    });
    setCurrentPage(1);
  }, []);

  // Initialize filter options on mount
  useEffect(() => {
    fetchFilterOptions();
  }, [fetchFilterOptions]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (filterTimeoutRef.current) {
        clearTimeout(filterTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const tableId = `#dataTable-${tableKey}`;
    
    // Clean up any existing DataTable instance first
    if ($.fn.DataTable.isDataTable(tableId)) {
      try {
        $(tableId).DataTable().destroy(false);
      } catch (error) {
        console.warn('Error destroying DataTable:', error);
      }
    }
    
    // Only initialize if data exists and we're not loading
    if (plantations.length > 0 && !loading) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        try {
          if (!$.fn.DataTable.isDataTable(tableId)) {
            $(tableId).DataTable({
              dom: 'Bfrtip',
              buttons: [
                'colvis',
              ],
              pageLength: perPage,
              responsive: true,
              destroy: true,
              searching: false,
              ordering: false,
              paging: false,
              info: false,
              deferRender: true,
              autoWidth: false,
            });
          }
        } catch (error) {
          console.warn('Error initializing DataTable:', error);
        }
      }, 100);
    }

    return () => {
      // Cleanup when component unmounts or dependencies change
      if ($.fn.DataTable.isDataTable(tableId)) {
        try {
          $(tableId).DataTable().destroy(false);
        } catch (error) {
          console.warn('Error in cleanup:', error);
        }
      }
    };
  }, [plantations, perPage, loading, tableKey]);

  const exportToCSV = async () => {
    try {
      const token = localStorage.getItem("token");
      toast.info("Preparing CSV for all pages... Please wait.");
      
      // Prepare active filters
      const activeFilters = {};
      Object.keys(filters).forEach(key => {
        if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
          activeFilters[key] = filters[key];
        }
      });

      // Robust request body construction for export
      const requestBody = {
        perPage: totalItems > 0 ? totalItems : 1000,
        pageNo: 1,
        ...activeFilters,   // flat spread only
      };
      
      const response = await axios.post(
        `${API_BASE_URL}/api/plantation/pafs/get-all-plantation`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );
      
      if (response.data.success) {
        const allPlantations = response.data.data || [];
        const csvContent = generateManualCSV(allPlantations);
        downloadCSV(csvContent, `plantation-data-all-${new Date().toISOString().split('T')[0]}.csv`);
        toast.success(`Successfully exported ${allPlantations.length} records.`);
      } else {
        toast.error("Failed to fetch data for export.");
      }
    } catch (error) {
      console.error('CSV export failed:', error);
      toast.error('Failed to export CSV');
    }
  };

  const generateManualCSV = (dataToExport) => {
    const headers = [
      'S.No.', 'Species Name', 'Category', 'Number of Plants', 'Province',
      'District', 'Tehsil', 'Year of Plantation', 'Plantation Campaign',
      'Plantation Type', 'Planted By', 'Remarks', 'Plantation Date'
    ];
    
    const csvRows = [headers.join(',')];
    
    dataToExport.forEach((plantation, index) => {
      const row = [
        index + 1,
        `"${renderSpeciesName(plantation.speciesName).replace(/"/g, '""')}"`,
        `"${(plantation.category || 'No Data Found').replace(/"/g, '""')}"`,
        plantation.numberOfPlants || 'No Data Found',
        `"${(plantation.province || 'No Data Found').replace(/"/g, '""')}"`,
        `"${(plantation.district || 'No Data Found').replace(/"/g, '""')}"`,
        `"${(plantation.tehsil || 'No Data Found').replace(/"/g, '""')}"`,
        plantation.plantationDate ? new Date(plantation.plantationDate).getFullYear() : 'No Data Found',
        `"${(plantation.plantationCampaign || 'No Data Found').replace(/"/g, '""')}"`,
        `"${(plantation.plantationType || 'No Data Found').replace(/"/g, '""')}"`,
        `"${(plantation.plantedBy || 'No Data Found').replace(/"/g, '""')}"`,
        `"${(plantation.publicRemarks || plantation.remark || 'No Data Found').replace(/"/g, '""').replace(/\n/g, ' ')}"`,
        `"${plantation.plantationDate ? new Date(plantation.plantationDate).toLocaleString() : 'No Data Found'}"`
      ];
      csvRows.push(row.join(','));
    });
    
    return csvRows.join('\n');
  };

  // Helper function to download CSV
  const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getStatusClasses = (category) => {
    const normalizedCategory = category?.toLowerCase().replace(/\s+/g, '').replace(/-/g, '') || '';

    switch (normalizedCategory) {
      case 'public':
        return 'bg-success-focus text-success-600';
      case 'departmental':
        return 'bg-warning-focus text-warning-600';
      default:
        return 'bg-secondary text-secondary-600';
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Data fetching is now handled by the useEffect watching currentPage
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Generate pagination items
  const generatePaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    // First and Previous buttons
    items.push(
      <li key="first" className="page-item">
        <button
          className={`page-link ${currentPage === 1 ? 'disabled' : ''}`}
          disabled={currentPage === 1}
          onClick={() => handlePageChange(1)}
        >
          First
        </button>
      </li>
    );
    
    items.push(
      <li key="prev" className="page-item">
        <button
          className={`page-link ${currentPage === 1 ? 'disabled' : ''}`}
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
      </li>
    );
    
    // Ellipsis for beginning
    if (startPage > 1) {
      items.push(
        <li key="ellipsis-start" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }
    
    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <li key={i} className="page-item">
          <button
            className={`page-link ${currentPage === i ? 'active' : ''}`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }
    
    // Ellipsis for end
    if (endPage < totalPages) {
      items.push(
        <li key="ellipsis-end" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }
    
    // Next and Last buttons
    items.push(
      <li key="next" className="page-item">
        <button
          className={`page-link ${currentPage === totalPages ? 'disabled' : ''}`}
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </li>
    );
    
    items.push(
      <li key="last" className="page-item">
        <button
          className={`page-link ${currentPage === totalPages ? 'disabled' : ''}`}
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          Last
        </button>
      </li>
    );
    
    return items;
  };

  // Calculate showing text
  const getShowingText = () => {
    if (totalItems === 0) {
      return "Showing 0 to 0 of 0 entries";
    }
    
    const start = ((currentPage - 1) * perPage) + 1;
    const end = Math.min(currentPage * perPage, totalItems);
    
    return `Showing ${start} to ${end} of ${totalItems} entries`;
  };

  return (
    <>
      {/* Filter Card */}
      <div className="card mb-4">
        <div className="card-header">
          <h5 className="card-title mb-0">Filters</h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-2">
              <label htmlFor="categoryFilter" className="form-label-table">Category</label>
              <select 
                id="categoryFilter"
                className="form-select"
                value={filters.category}
                onChange={(e) => handleFilterChange('category', e.target.value)}
              >
                <option value="">All Categories</option>
                {filterOptions.categories.map((category, index) => (
                  <option key={index} value={category}>{category}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <label htmlFor="provinceFilter" className="form-label-table">Province</label>
              <select 
                id="provinceFilter"
                className="form-select"
                value={filters.province}
                onChange={(e) => handleFilterChange('province', e.target.value)}
              >
                <option value="">All Provinces</option>
                {filterOptions.provinces.map((province, index) => (
                  <option key={index} value={province}>{province}</option>
                ))}
              </select>
            </div>
            
            <div className="col-md-2">
              <label htmlFor="districtFilter" className="form-label-table">District</label>
              <select 
                id="districtFilter"
                className="form-select"
                value={filters.district}
                onChange={(e) => handleFilterChange('district', e.target.value)}
              >
                <option value="">All Districts</option>
                {filterOptions.districts.map((district, index) => (
                  <option key={index} value={district}>{district}</option>
                ))}
              </select>
            </div>
            
            
            
            <div className="col-md-2">
              <label htmlFor="tehsilFilter" className="form-label-table">Tehsil</label>
              <select 
                id="tehsilFilter"
                className="form-select"
                value={filters.tehsil}
                onChange={(e) => handleFilterChange('tehsil', e.target.value)}
              >
                <option value="">All Tehsils</option>
                {filterOptions.tehsils.map((tehsil, index) => (
                  <option key={index} value={tehsil}>{tehsil}</option>
                ))}
              </select>
            </div>
            
            <div className="col-md-2">
              <label htmlFor="campaignFilter" className="form-label-table">Campaign</label>
              <select 
                id="campaignFilter"
                className="form-select"
                value={filters.plantationCampaign}
                onChange={(e) => handleFilterChange('plantationCampaign', e.target.value)}
              >
                <option value="">All Campaigns</option>
                {filterOptions.plantationCampaigns.map((campaign, index) => (
                  <option key={index} value={campaign}>{campaign}</option>
                ))}
              </select>
            </div>
            
            <div className="col-md-2">
              <label htmlFor="typeFilter" className="form-label-table">Plantation Type</label>
              <select 
                id="typeFilter"
                className="form-select"
                value={filters.plantationType}
                onChange={(e) => handleFilterChange('plantationType', e.target.value)}
              >
                <option value="">All Types</option>
                {filterOptions.plantationTypes.map((type, index) => (
                  <option key={index} value={type}>{type}</option>
                ))}
              </select>
            </div>
            
            <div className="col-md-2">
                <label className="form-label-table">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={filters.fromDate}
                  onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label-table">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={filters.toDate}
                  onChange={(e) => handleFilterChange('toDate', e.target.value)}
                />
              </div>

            
            <div className="col-md-2">
              <label htmlFor="siteTypeFilter" className="form-label-table">Site Type</label>
              <select 
                id="siteTypeFilter"
                className="form-select"
                value={filters.siteType}
                onChange={(e) => handleFilterChange('siteType', e.target.value)}
              >
                <option value="">All Site Types</option>
                {filterOptions.siteTypes.map((siteType, index) => (
                  <option key={index} value={siteType}>{siteType}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label htmlFor="searchFilter" className="form-label-table">Search</label>
              <input 
                type="text"
                id="searchFilter"
                className="form-control h-40-px"
                placeholder="Search species, remark..."
                value={filters.searchQuery || ''}
                onChange={(e) => handleFilterChange('searchQuery', e.target.value)}
              />
            </div>
            
            <div className="col-md-2 d-flex align-items-end">
              <button 
                className="btn btn-outline-secondary w-100 h-40-px d-flex align-items-center justify-content-center"
                onClick={clearFilters}
              >
                <Icon icon="mdi:filter-off-outline" className="me-1" />
                Clear Filters
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Data Table Card */}
      <div className="card basic-data-table">
        <ToastContainer />
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">Plantation Data</h5>
          <div className="export-buttons d-flex align-items-center">
            <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
              <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} />
              CSV
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>{getShowingText()}</div>
          </div>
          
          <div className="table-responsive" key={loading ? 'loading' : tableKey}>
            <table 
              ref={tableRef}
              className="table vertical-striped-table mb-0" 
              id={`dataTable-${tableKey}`} // Unique ID for each render
              data-page-length={perPage}
            >
              <thead>
                <tr>
                  <th scope="col" className="bg-success-300">S.No.</th>
                  <th scope="col" className="bg-success-300">Species Name</th>
                  <th scope="col" className="bg-success-300">Category</th>
                  <th scope="col" className="bg-success-300">Number of Plants</th>
                  <th scope="col" className="bg-success-300">Province</th>
                  <th scope="col" className="bg-success-300">District</th>
                  <th scope="col" className="bg-success-300">Tehsil</th>
                  <th scope="col" className="bg-success-300">Year of Plantation</th>
                  <th scope="col" className="bg-success-300">Plantation Campaign</th>
                  <th scope="col" className="bg-success-300">Plantation Type</th>
                  <th scope="col" className="bg-success-300">Planted By</th>
                  <th scope="col" className="bg-success-300">Remarks</th>
                  <th scope="col" className="bg-success-300">Plantation Date</th>
                  <th scope="col" className="bg-success-300">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: perPage }).map((_, index) => (
                    <tr key={index}>
                      <td><Skeleton width={30} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={80} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={80} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={120} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={100} /></td>
                    </tr>
                  ))
                ) : plantations && plantations.length > 0 ? (
                  plantations.map((plantation, index) => (
                    <tr key={plantation._id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>{renderSpeciesName(plantation.speciesName)}</td>
                      <td>
                        <span className={`px-16 py-6 rounded-pill fw-semibold text-xs ${getStatusClasses(plantation.category)}`}>
                          {plantation.category || 'No Data Found'}
                        </span>
                      </td>
                      <td>{plantation.numberOfPlants || 'No Data Found'}</td>
                      <td>{plantation.province || 'No Data Found'}</td>
                      <td>{plantation.district || 'No Data Found'}</td>
                      <td>{plantation.tehsil || 'No Data Found'}</td>
                      <td>{plantation.plantationDate ? new Date(plantation.plantationDate).getFullYear() : 'No Data Found'}</td>
                      <td>{plantation.plantationCampaign || 'No Data Found'}</td>
                      <td>{plantation.plantationType || 'No Data Found'}</td>
                      <td>{plantation.plantedBy || 'No Data Found'}</td>
                      <td>
                      <TooltipTextPopupCustom
                          text={plantation.publicRemarks || plantation.remark || 'No Data Found'}
                          truncateLength={16}
                          placement="left"
                          customClass="tooltip-info"
                      />
                      </td>
                      <td>{new Date(plantation.plantationDate).toLocaleString() || 'No Data Found'}</td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          {hasPermission('plantations', 'view') && (
                            <Link
                              to={`/plantation/view/${plantation._id}`}
                              className="text-primary-600 hover-text-primary d-flex align-items-center gap-1 "
                            >
                              Show Details
                            </Link>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="text-center">
                      No plantations found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {/* Pagination Controls */}
          {!loading && totalItems > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>{getShowingText()}</div>
              <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                  {generatePaginationItems()}
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlantationTableLayer;